export default "__VITE_ASSET__BaqVl42L__"